<template>
  <div>
    <header class="voucher-header" v-if="device === 'mobile'">
      <h1 class="a11y-hidden">웨이브</h1>
      <div class="header-top">
        <h2 class="hd-title">이용권</h2>

        <button class="btn-back" type="button" @click.prevent="close">
          <span class="a11y-hidden">뒤로 가기</span>
          <span class="icon-back"><BackButton /> </span>
        </button>

        <button class="btn-close" type="button" @click.prevent="close">
          <span class="a11y-hidden">나가기</span>
          <span class="icon-close"><CloseButton/></span>
        </button>
      </div>
      <common-main-menu v-if="$route.name !== 'voucher_promotion'" :menu-items="menuItems" :menu-index="mainMenuIndex" :change-menu-fn="changeMainMenu" />
    </header>
    <div v-if="$route.name === 'voucher_promotion'" :class="'voucher-view-oksusu' + (device !== 'mobile' ? ' not-mobile' : '')">
      <router-view name="voucher_promotion" key="voucher_promotion"></router-view>
    </div>
    <div v-else :class="'voucher-view' + (device !== 'mobile' ? ' not-mobile' : '')">
      <router-view name="index" key="index"></router-view>
      <router-view name="regist" key="regist"></router-view>
      <router-view name="pooqzone" key="pooqzone"></router-view>
    </div>
  </div>
</template>

<script>
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import CloseButton from '@/assets/svg/common/ic_gnb_close_w.svg'
import { mapGetters } from 'vuex'
import CommonMainMenu from '@/components/lnb/mypooq/CommonMainMenu'
import { MY_POOQ_VOUCHER_MENU_LIST } from '@/common/menu.constant'
import utils from '@/common/util/utils'

export default {
  name: 'Voucher',
  components: {
    CommonMainMenu,
    BackButton,
    CloseButton
  },
  data () {
    return {
      routeMenu: '',
      menuItems: MY_POOQ_VOUCHER_MENU_LIST,
      mainMenuIndex: 0,
      device: utils.cookies.getDevice()
    }
  },
  created () {
    const lastPath = this.$route.path.split('/').pop()
    if (lastPath === 'voucher') {
      this.$router.replace({ name: 'index' })
    }
    switch (lastPath) {
      case 'index':
        this.mainMenuIndex = 0
        break
      case 'regist':
        this.mainMenuIndex = 1
        break
      case 'wavveon':
      case 'pooqzone':
        this.mainMenuIndex = 2
        break
    }
  },
  computed: {
    ...mapGetters(['getBeforePathOpenMyPooq'])
  },
  methods: {
    changeMainMenu (mainMenuObject) {
      this.mainMenuIndex = mainMenuObject.index
      this.$router.push(mainMenuObject.path)
    },
    close () {
      this.$router.replace(this.getBeforePathOpenMyPooq)
    }
  },
  beforeUpdate () {
    const lastPath = this.$route.path.split('/').pop()
    let menuItem = this.menuItems.filter((menu) => {
      return menu.value === lastPath
    })
    if (menuItem.length > 0 && this.mainMenuIndex !== menuItem[0].index) {
      this.mainMenuIndex = menuItem[0].index
    }
  }
}
</script>

<style lang="css" scoped>
  .voucher-header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
  }
  .voucher-view {
    height: 100vh;
    padding-top: 80px;
  }
  .voucher-view.not-mobile {
    padding-top: 0;
  }
  .voucher-view.not-mobile,
  .voucher-view-oksusu.not-mobile{
    padding-top: 0;
  }
  .voucher-view-oksusu {
    padding-top: 40px;
  }
</style>
